import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children, accessToken }) => {
  return accessToken ? children : <Navigate to="/sign-in" />;
};

export default PrivateRoute;
